import { request } from './request'
const biBaseURL = process.env.VUE_APP_BASEURL_BI
const api = '/template/query/name/v1'
// paypal新增/修改接口
export const setPaypalAccount = data => {
    return request({
        method: 'post',
        url: '/ocean/api/v1/shop/paypal/addOrUpdate',
        data: data
    })
}
// paypal配置列表接口
export const getPaypalList = data => {
    return request({
        method: 'post',
        url: '/ocean/api/v1/shop/paypal/page',
        data: data
    })
}
// 删除PayPal账号
export const deletePaypalAccount = id => {
    return request({
        method: 'delete',
        url: `/ocean/api/v1/shop/paypal/delete/${id}`,
    })
}
// 重新授权PayPal账号
export const resetPaypalAccount = id => {
    return request({
        method: 'post',
        url: `/ocean/api/v1/shop/paypal/getBindUrl/${id}`,
    })
}
// 授权回调PayPal账号
export const authPaypalAccount = data => {
    return request({
        method: 'post',
        url: `/ocean/api/v1/shop/paypal/callBack`,
        data,
        notMsg: true
    })
}
// paypal获取报警设置条件列表
export const getPaypalQueryList = params => {
    return request({
        method: 'get',
        url: `/ocean/api/v1/shop/paypal/queryList`,
        params
    })
}
// paypal获取报警设置
export const getPaypalWarningSetting = params => {
    return request({
        method: 'get',
        url: `/ocean/api/v1/shop/paypal/warning/get`,
        params
    })
}
// paypal修改报警设置
export const updatePaypalWarningSetting = data => {
    return request({
        method: 'post',
        url: `/ocean/api/v1/shop/paypal/warning/save`,
        data
    })
}


// Paypal监控-账户数据概览
export const getPaypalOverview = data => {
    return request({
        method: 'post',
        url: `${biBaseURL}${api}`,
        data: {
            template_id: 'load.shoplus.bi.paypal.overview',
            params: data
        }
    })
}
// Paypal监控-账户数据明细
export const getPaypalDetailList = data => {
    return request({
        method: 'post',
        url: `${biBaseURL}${api}`,
        data: {
            template_id: 'load.shoplus.bi.paypal.detail',
            params: data
        }
    })
}
// Paypal监控-账户数据明细弹窗数据
export const getPaypalDetail = data => {
    return request({
        method: 'post',
        url: `${biBaseURL}${api}`,
        data: {
            template_id: 'load.shoplus.bi.paypal.window',
            params: data
        }
    })
}
